import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { tabUntuk, type NavHub } from '../lib/nav-hub';

/**
 * Tab grup di atas halaman (#1758) — mis. "Semua tugas | Tugas saya" di grup Tugas.
 *
 * Tab di sini TAUTAN, sengaja berbeda dari tab Laporan yang berupa tombol: tiap tab adalah layar
 * tersendiri dengan rutenya sendiri (sudah ada sebelum pengelompokan), jadi tautan yang dapat
 * dibagikan dan tombol Kembali yang berfungsi justru perilaku yang diharapkan.
 *
 * Tidak dirender sama sekali di layar yang bukan daftar anggota grup (detail, formulir) — aturan
 * itu ada di `tabUntuk`, bukan di CSS.
 */
export function HubTabs({ hubs }: { readonly hubs: readonly NavHub[] }): ReactNode {
  const { pathname } = useLocation();
  const tab = tabUntuk(hubs, pathname);
  if (!tab) return null;

  return (
    <nav className="tab-bar hub-tabs" aria-label={tab.hub.label}>
      {tab.hub.members.map((m) => (
        <NavLink
          key={m.to}
          to={m.to}
          end
          className={m.to === tab.aktif ? 'tab tab-aktif' : 'tab'}
          aria-current={m.to === tab.aktif ? 'page' : undefined}
        >
          {m.label}
        </NavLink>
      ))}
    </nav>
  );
}
